import FeedviewFilters from './FeedviewFilters';

export default FeedviewFilters;
